// extracted by mini-css-extract-plugin
export default {"restoreTasks":"index-module__bREmf","buttonWrapper":"index-module__h6CDN","viewDetails":"index-module__Y2BLe","headerOuter":"index-module__udo8w"};